<template>
  <v-layout row fill-height style="overflow-y: auto; background: var(--page-back)">
    
    <v-flex xs12 class="fill-height" v-if="!zohoReady">
      <v-layout column align-center justify-space-around fill-height>
        <v-flex shrink>
          <v-card width="400">
            <v-card-title class="pa-1 pl-2">
              <span class="subheading font-weight-light primary--text">Login</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div class="pa-2">Login To Zoho Mail</div>
              <div class="text-xs-right pa-2">
                <v-btn large flat color="blue" @click="authorize">
                  <img src="../../../../public/zoho.svg" width="70px">
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    
    <template v-else>
      <v-flex v-show="!showLinkToZoho" xs3 class="fill-height c-d-flex c-flex-column pa-1"
              style="overflow-y: auto; background: var(--page-back)">
        <div class="c-flex-grow-0 pt-1">
          <app-mailbox-switch
              :user-info="userInfo"
              :zoho-config="zohoConfig"
              v-model="selectedAddress"
              @newToken="authorize"
          />
          
          <div class="c-d-flex c-justify-center">
            <v-btn class="mx-auto" large flat color="blue" @click="zohoMailReplyCompose(0)">
              <img src="../../../../public/zohoLogo.svg" height="24px" class="nav-item pr-2">
              Compose Message
            </v-btn>
          </div>
        
        
        </div>
        <div class="c-flex-grow-1 of-y">
          
          <app-folders
              :user-info="userInfo"
              :selected-address="selectedAddress"
              :selected-label.sync="selectedLabel"
              @update:selectedLabel="console.log('test')"
          />
          
          <!--          getMessagesForFolder($event.id); searchOptions = {-->
          <!--          searchText: '',-->
          <!--          from: '',-->
          <!--          to: '',-->
          <!--          subject: '',-->
          <!--          hasWords: '',-->
          <!--          noWords: '',-->
          <!--          hasAttachment: false,-->
          <!--          starred: false-->
          <!--          }; selectedMessage = null-->
          
          <!--          :fn-load-sub-folders="getChildFolders"-->
          
          
          <!--          @droppedLabel="moveMessageToFolder($event)"-->
        </div>
      
      
      </v-flex>
      <v-flex :xs3="!showLinkToZoho" :xs4="showLinkToZoho" style="overflow-y: auto; background: var(--page-back)"
              class="fill-height px-1" v-if="zohoReady && zohoConfig.addresses.length">
        <v-layout fill-height column>
          <v-flex shrink>
            <app-search-menu
                :search-options.sync="searchOptions"
            />
          </v-flex>
          <v-flex style="overflow-y: auto" xs12>
            
            <div class="fill-height of-y" style="position: relative">
              <app-mail-bar
                  :userInfo="userInfo"
                  :selected-address="selectedAddress"
                  :selected-label="selectedLabel"
                  :search-options="searchOptions"
                  :get-task-header="getTaskHeader"
                  :selected-message.sync="selectedMessage"
              />
              
              <div style="position: absolute; left: 0; top: 0" v-if="showLinkToZoho">
                <v-tooltip right>
                  <v-btn
                      fab
                      dark
                      small
                      color="secondary"
                      @click="eventBus.$emit('linkZohoMail', false)"
                      slot="activator"
                      class="pa-0 ma-1"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                  <span>Cancel</span>
                </v-tooltip>
              </div>
              
            </div>
            
            
<!--            @selectMessage="selectMessage($event)"-->
<!--            @dragMessage="dragMessage = $event"-->
<!--            :selected-message="selectedMessage"-->
<!--            :load-more-fn="loadMoreMessages"-->
<!--            :loading-next="loadingMoreMessages"-->
<!--            -->
<!--            :movingMessage="movingMessage"-->
<!--            :dragMessage="dragMessage"-->
<!--            :archive-message-fn="archiveMessage"-->
<!--            :flag-message-fn="flagMessage"-->
<!--            @showLinkToZoho="$emit('showLinkToZoho', $event)"-->
<!--            :user-principal="userPrincipal"-->
          
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex :xs6="!showLinkToZoho" :xs8="showLinkToZoho" style="overflow-y: auto; background: var(--page-back)"
              class="fill-height px-1" v-if="zohoReady && zohoConfig.addresses.length && selectedMessage != null">
        <message-view
            :userInfo="userInfo"
            :selected-address="selectedAddress"
            :selected-label="selectedLabel"
            :search-options="searchOptions"
            :get-task-header="getTaskHeader"
            :selected-message.sync="selectedMessage"
        >
        
        </message-view>
      </v-flex>
    </template>
    
    
    <!--&lt;!&ndash;Loading Zoho&ndash;&gt;-->
    <!--        <v-flex xs12 v-if="zohoConfig.loadingAddress && !showLogin" class="fill-height">-->
    <!--            <v-layout column align-center justify-space-around fill-height>-->
    <!--                <v-flex shrink>-->
    <!--                    <v-progress-circular-->
    <!--                            :size="40"-->
    <!--                            :width="5"-->
    <!--                            color="primary"-->
    <!--                            indeterminate-->
    <!--                    ></v-progress-circular>-->
    <!--                </v-flex>-->
    <!--            </v-layout>-->
    <!--        </v-flex>-->
    <!--&lt;!&ndash;Login To Office&ndash;&gt;-->
    <!--        -->
    <!--&lt;!&ndash;MailBar&ndash;&gt;-->
    <!--            <v-flex :xs3="!showLinkToZoho" :xs4="showLinkToZoho"  style="overflow-y: auto; background: var(&#45;&#45;page-back)" class="fill-height px-1" v-if="zohoConfig.running && !showLogin && userPrincipal != null">-->
    <!--                <v-layout fill-height column>-->
    <!--                    <v-flex shrink>-->
    <!--                        <app-search-menu-->
    <!--                                :searchOptions="searchOptions"-->
    <!--                                @runSearch="getSearchMessages(); selectedMessage = null"-->
    <!--                                v-if="!loadingMessages"-->
    <!--                        />-->
    <!--                    </v-flex>-->
    <!--                    <v-flex style="overflow-y: auto" xs12>-->
    <!--                        <app-mail-bar-->
    <!--                                :show-loading="loadingMessages"-->
    <!--                                :userInfo="userInfo"-->
    <!--                                :messages="messageList"-->
    <!--                                :nextLink="nextLink"-->
    <!--                                @selectMessage="selectMessage($event)"-->
    <!--                                :selected-message="selectedMessage"-->
    <!--                                :load-more-fn="loadMoreMessages"-->
    <!--                                :loading-next="loadingMoreMessages"-->
    <!--                                @dragMessage="dragMessage = $event"-->
    <!--                                :movingMessage="movingMessage"-->
    <!--                                :dragMessage="dragMessage"-->
    <!--                                :archive-message-fn="archiveMessage"-->
    <!--                                :flag-message-fn="flagMessage"-->
    <!--                                @showLinkToZoho="$emit('showLinkToZoho', $event)"-->
    <!--                                :user-principal="userPrincipal"-->
    <!--                        />-->
    <!--                    </v-flex>-->
    <!--                </v-layout>-->
    <!--            </v-flex>-->
    <!--&lt;!&ndash;Message Pane&ndash;&gt;-->
    <!--        <v-flex :xs6="!showLinkToZoho" :xs8="showLinkToZoho" class="fill-height  pa-2" style="overflow-y: auto" v-if="zohoConfig.running && !showLogin && selectedMessage != null">-->
    <!--            <template v-if="!loadedMessages.includes(selectedMessage.id)">-->
    
    <!--                <v-layout column justify-center align-center fill-height>-->
    <!--                    <v-flex shrink class="text-xs-center">-->
    <!--                        <v-progress-circular-->
    <!--                                :size="40"-->
    <!--                                :width="5"-->
    <!--                                color="primary"-->
    <!--                                indeterminate-->
    <!--                        ></v-progress-circular>-->
    <!--                    </v-flex>-->
    <!--                </v-layout>-->
    <!--            </template>-->
    <!--            <e-m-l-viewer v-else :filename="selectedMessage.filename" :cache="true" ref="emlView">-->
    <!--                <template slot="metaTop">-->
    <!--&lt;!&ndash;Create Task&ndash;&gt;-->
    <!--                    <v-tooltip top v-if="typeof userInfo.createTask != 'undefined' && intToBool(userInfo.createTask)">-->
    <!--                        <v-btn-->
    <!--                                icon-->
    <!--                                dark-->
    <!--                                small-->
    <!--                                color="secondary"-->
    <!--                                @click="$emit('createTaskOffice', {...selectedMessage, attachments: $refs.emlView.messageData.attachments}); $emit('showLinkToZoho', false)"-->
    <!--                                slot="activator"-->
    <!--                                class="pt-0 mx-1 mt-1 elevation-5"-->
    <!--                        >-->
    <!--                            <v-icon small>add</v-icon>-->
    <!--                        </v-btn>-->
    <!--                        <span>Create Task</span>-->
    <!--                    </v-tooltip>-->
    <!--&lt;!&ndash;Link To Task&ndash;&gt;-->
    <!--                    <v-tooltip top>-->
    <!--                        <v-btn-->
    <!--                                icon-->
    <!--                                dark-->
    <!--                                small-->
    <!--                                color="secondary"-->
    <!--                                @click="$emit('showLinkToZoho', true); $emit('setOfficeMail', {...selectedMessage, attachments: $refs.emlView.messageData.attachments})"-->
    <!--                                slot="activator"-->
    <!--                                class="pt-0 mx-1 mt-1 elevation-5"-->
    <!--                        >-->
    <!--                            <v-icon small>link</v-icon>-->
    <!--                        </v-btn>-->
    <!--                        <span>Link To Task</span>-->
    <!--                    </v-tooltip>-->
    <!--&lt;!&ndash;Reply&ndash;&gt;-->
    <!--                    <v-tooltip top>-->
    <!--                        <v-btn-->
    <!--                                icon-->
    <!--                                dark-->
    <!--                                small-->
    <!--                                color="secondary"-->
    <!--                                @click="newMail(1)"-->
    <!--                                slot="activator"-->
    <!--                                class="pt-0 mx-1 mt-1 elevation-5"-->
    <!--                        >-->
    <!--                            <v-icon small>reply</v-icon>-->
    <!--                        </v-btn>-->
    <!--                        <span>Reply</span>-->
    <!--                    </v-tooltip>-->
    <!--&lt;!&ndash;Reply To All&ndash;&gt;-->
    <!--                    <v-tooltip top>-->
    <!--                        <v-btn-->
    <!--                                icon-->
    <!--                                dark-->
    <!--                                small-->
    <!--                                color="secondary"-->
    <!--                                @click="newMail(2)"-->
    <!--                                slot="activator"-->
    <!--                                class="pt-0 mx-1 mt-1 elevation-5"-->
    <!--                        >-->
    <!--                            <v-icon small>reply_all</v-icon>-->
    <!--                        </v-btn>-->
    <!--                        <span>Reply To All</span>-->
    <!--                    </v-tooltip>-->
    <!--&lt;!&ndash;Forward&ndash;&gt;-->
    <!--                    <v-tooltip top>-->
    <!--                        <v-btn-->
    <!--                                icon-->
    <!--                                dark-->
    <!--                                small-->
    <!--                                color="secondary"-->
    <!--                                @click="newMail(3)"-->
    <!--                                slot="activator"-->
    <!--                                class="pt-0 mx-1 mt-1 elevation-5"-->
    <!--                        >-->
    <!--                            <v-icon small>forward</v-icon>-->
    <!--                        </v-btn>-->
    <!--                        <span>Forward Mail</span>-->
    <!--                    </v-tooltip>-->
    
    <!--                    &lt;!&ndash;Tasks&ndash;&gt;-->
    <!--                    <template v-if="typeof selectedMessage.tasks != 'undefined' && selectedMessage.tasks.length > 0 && !resetTasks">-->
    <!--                        <template v-for="task in selectedMessage.tasks">-->
    <!--                            <v-menu open-on-hover offset-y nudge-left="150px" :key="task">-->
    <!--                                <v-chip-->
    <!--                                        slot="activator"-->
    <!--                                        small-->
    <!--                                        label-->
    <!--                                        color="secondary"-->
    <!--                                        text-color="white"-->
    <!--                                        class="elevation-5"-->
    <!--                                >-->
    <!--                                    <v-icon small class="pr-2">assignment_turned_in</v-icon>-->
    <!--                                    Task #{{task}}-->
    <!--                                </v-chip>-->
    <!--                                <div style="width: 400px; background: var(&#45;&#45;card-back); cursor: pointer">-->
    <!--                                    <task-loading-container-->
    <!--                                            v-if="typeof loadedTasks[task] == 'undefined' || loadedTasks[task] == null"-->
    <!--                                            :task-id="task"-->
    <!--                                    />-->
    <!--                                    <task-container-->
    <!--                                            v-else-->
    <!--                                            :userInfo="userInfo"-->
    <!--                                            :task="loadedTasks[task]"-->
    <!--                                            :taskBar="false"-->
    <!--                                            :showNav="false"-->
    <!--                                            @taskSelected="taskSelected(loadedTasks[task])"-->
    <!--                                    />-->
    <!--                                </div>-->
    <!--                            </v-menu>-->
    <!--                        </template>-->
    <!--                    </template>-->
    
    <!--                    <template v-if="typeof userInfo.createTask != 'undefined' && intToBool(userInfo.createTask)">-->
    <!--                        <v-tooltip-->
    <!--                                top-->
    <!--                                v-for="(qt, i) in [...userInfo.quickTasks].sort((a, b) => a.config.order - b.config.order)"-->
    <!--                                :key="i"-->
    <!--                        >-->
    <!--                            <v-btn-->
    <!--                                    icon-->
    <!--                                    dark-->
    <!--                                    outline-->
    <!--                                    small-->
    <!--                                    color="secondary"-->
    <!--                                    @click="$emit('createTaskOffice', {...selectedMessage, attachments: $refs.emlView.messageData.attachments, qt: qt.config}); $emit('showLinkToZoho', false)"-->
    <!--                                    slot="activator"-->
    <!--                                    class="pt-0 mx-1 mt-1 elevation-5"-->
    <!--                            >-->
    <!--                                <v-icon small>{{ qt.config.icon }}</v-icon>-->
    <!--                            </v-btn>-->
    <!--                            <span>Create {{qt.config.description}} Task</span>-->
    <!--                        </v-tooltip>-->
    <!--                    </template>-->
    <!--                </template>-->
    <!--            </e-m-l-viewer>-->
    
    
    <!--&lt;!&ndash;            <app-message-view&ndash;&gt;-->
    <!--&lt;!&ndash;                    :message="selectedMessage"&ndash;&gt;-->
    <!--&lt;!&ndash;                    :showLoading="false"&ndash;&gt;-->
    <!--&lt;!&ndash;                    :flag-message-fn="flagMessage"&ndash;&gt;-->
    <!--&lt;!&ndash;                    :user-info="userInfo"&ndash;&gt;-->
    <!--&lt;!&ndash;                    @showLinkToZoho="$emit('showLinkToZoho', $event)"&ndash;&gt;-->
    <!--&lt;!&ndash;                    :show-link-office="showLinkToZoho"&ndash;&gt;-->
    <!--&lt;!&ndash;                    @setOfficeMail="$emit('setOfficeMail', $event)"&ndash;&gt;-->
    <!--&lt;!&ndash;                    :folder-groups="taskData.folderGroups"&ndash;&gt;-->
    <!--&lt;!&ndash;                    @createTaskOffice="$emit('createTaskOffice', $event)"&ndash;&gt;-->
    <!--&lt;!&ndash;                    @setQT="$emit('setQT', $event)"&ndash;&gt;-->
    <!--&lt;!&ndash;                    :new-message-fn="newMessageFn"&ndash;&gt;-->
    <!--&lt;!&ndash;                    :get-task-header="getTaskHeader"&ndash;&gt;-->
    <!--&lt;!&ndash;                    :loaded-messages="loadedMessages"&ndash;&gt;-->
    <!--&lt;!&ndash;                    :cur-view="curView"&ndash;&gt;-->
    <!--&lt;!&ndash;            />&ndash;&gt;-->
    <!--        </v-flex>-->
    
    <create-mail v-if="showCreateMail" v-model="showCompose" ref="createMail"/>
  </v-layout>
</template>

<script>
import {codeBaseMixin} from "@/codeBaseMixin";
import {eventBus} from "@/main";
import Folders from "./Components/Folders";
import SearchMenu from "./Components/SearchMenu";
import MailBar from "./Components/MailBar";
import MailboxSwitch from "./Components/mailboxSwitch";
import tokenMan from '../../../tokenManSite';
import {feed} from "@/feedSocket";
import EMLViewer from "../../EML Viewer/EMLViewer";
import TaskContainer from "../../../components/TaskContainer/TaskContainer";
import TaskLoadingContainer from "../../../components/TaskContainer/TaskLoadingContainer";
import CreateMail from "@/Mail/Create Mail/CreateMail";
import {mapGetters} from "vuex";
import {serverAddress} from "@/axiosRequest";
import {token} from "@/tokenManSite";
import MessageView from "@/Mail/Combined Mail/Zoho/Components/MessageView.vue";

export default {
  components: {
    MessageView,
    appMailboxSwitch: MailboxSwitch,
    appMessageView: MessageView,
    appMailBar: MailBar,
    appSearchMenu: SearchMenu,
    appFolders: Folders,
    EMLViewer: EMLViewer,
    TaskLoadingContainer,
    TaskContainer,
    CreateMail
  },
  mixins: [codeBaseMixin],
  props: {
    userInfo: Object,
    taskData: Object,
    zohoConfig: Object,
    newMessageFn: Function,
    getTaskHeader: Function,
    curView: String,
  },
  data() {
    return {
      showCreateMail: false,
      eventBus,
      showLinkToZoho: false,
      console,
      selectedAddress: null,
      selectedLabel: null,
      inSearch: false,
      searchOptions: {
        searchText: '',
        from: '',
        to: '',
        subject: '',
        hasWords: '',
        noWords: '',
        hasAttachment: false,
        starred: false
      },
      selectedMessage: null,
      showCompose: false
    }
  },
  watch: {
    selectedLabel: {
      immediate: true,
      deep: true,
      handler(val) {
        this.searchOptions = {
          searchText: '',
          from: '',
          to: '',
          subject: '',
          hasWords: '',
          noWords: '',
          hasAttachment: false,
          starred: false
        }
      }
    }
  },
  created() {
    // eventBus.$on('mailLinkedToTaskOffice', this.mailLinkedToTaskOffice);
    // feed.on('microsoftOfficeMessagesDownload', this.microsoftOfficeMessagesDownload);
    //
    // this.getAndSetDefaultuserPrincipal();
  },
  beforeDestroy() {
    // eventBus.$off('mailLinkedToTaskOffice', this.mailLinkedToTaskOffice);
    // feed.off('microsoftOfficeMessagesDownload', this.microsoftOfficeMessagesDownload);
    eventBus.$off('linkZohoMail', this.linkZohoToggle);
    eventBus.$off('zohoMailReplyCompose', this.zohoMailReplyCompose);
  },
  mounted() {
    // this.initOffice();
    eventBus.$on('linkZohoMail', this.linkZohoToggle);
    eventBus.$on('zohoMailReplyCompose', this.zohoMailReplyCompose);
  },
  methods: {
    
    async zohoMailReplyCompose(type, message) {
      const vm = this
      function awaitNextTick() {
        return new Promise(resolve => {
          vm.$nextTick(() => {resolve(true)})
        });
      }
      
      try {
        if (message) eventBus.$emit('zohoShowMessageLoading', {messageId: message.messageId, value: true});
        
        
        
        this.showCreateMail = false
        await awaitNextTick()
        this.showCreateMail = true
        await awaitNextTick()
        
        this.$refs.createMail.init(type, type > 0 ? {
          tokenId: this.selectedAddress?.tokenId,
          folderId: this.selectedLabel?.folderId,
          messageId: this.selectedMessage?.messageId,
        } : null, 'zoho')
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        eventBus.$emit('zohoShowMessageLoading', {messageId: message.messageId, value: false});
      }
    },
    
    linkZohoToggle(show) {
      this.showLinkToZoho = show;
    },
    
    authorize() {
      console.log('AUTH')
      const curUrl = encodeURIComponent(window.location.href);
      const tokenStr = decodeURIComponent(token());
      window.location.assign(`${serverAddress}/zoho/auth/${tokenStr}/${curUrl}`);
    },
    
  },
  computed: {
    zohoReady() {
      return this.zohoConfig && this.zohoConfig.addresses.length;
    }
    
  }
}
</script>

<style scoped>

</style>
